import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import relps from "@/data/forms/mixins/relps.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import actionFunctions from "@/business/actions/mixins/actionFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  // eslint-disable-next-line
  mixins: [
    dataSources,
    getData,
    actionFunctions,
    relps,
    describeDocument
  ],
  computed: {
    ...mapGetters(["getDetailRelps", "getDetailSource"])
  },
  methods: {
    generateInitialRelps(u) {
      // this.generateDocumentRevForm();
      this.appendFirstRelpsChangeTracker(u);
    },
    generateInitialRelationships(tag) {
      let form = null;
      if (tag === "U1") {
        form = this.formRelpsUser;
      } else if (tag === "C1") {
        form = this.formRelpsCompany;
      } else if (tag === "G1") {
        form = this.formRelpsAccess;
      } else if (tag === "F1") {
        form = this.formRelpsFacility;
      } else if (tag === "A1") {
        form = this.formRelpsAsset;
      } else if (tag === "B1" || tag === "S6") {
        form = this.formRelpsIncidentRisk;
      } else if (tag === "B4") {
        form = this.formRelpsBudget;
      } else if (tag === "B6") {
        form = this.formRelpsPlan;
      } else if (tag === "B3") {
        form = this.formRelpsAction;
      } else if (tag === "Q1") {
        form = this.formRelpsOrder;
      } else if (tag === "W1") {
        form = this.formRelpsWorkRequest;
      } else if (tag === "W2") {
        form = this.formRelpsWorkCall;
      } else if (tag === "W3") {
        form = this.formRelpsResource;
      } else if (tag === "W6") {
        form = this.formRelpsProcedure;
      } else if (tag === "E6") {
        form = this.formRelpsProgram;
      } else if (tag === "E2") {
        form = this.formRelpsEngineering;
      } else if (tag === "E1") {
        form = this.formRelpsEquipment;
      } else if (tag === "L1") {
        form = this.formRelpsMaterial;
      } else if (tag === "L2") {
        form = this.formRelpsMaterialList;
      } else if (tag === "M2") {
        form = this.formRelpsMaintStrategy;
      } else if (tag === "M5") {
        form = this.formRelpsMaintPlan;
      } else if (tag === "M4") {
        form = this.formRelpsMaintenanceCall;
      } else if (tag === "S1") {
        form = this.formRelpsHazard;
      } else {
        form = null;
      }
      return form;
    }
  }
};
